/**
 * Testing new header copy on logged out homepage top banner
 */ export var LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224 = 'LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224';
